import { createApp } from 'vue'

import { Quasar, Loading, Notify } from 'quasar'

import router from './router'

// Import i18n
import { createI18n } from 'vue-i18n'
import { ruRU } from '@/shared/i18n'

const i18nInstance = createI18n({
    legacy: false,
    locale: 'ru-RU',
    fallbackLocale: 'ru-RU',
    messages: {
        'ru-RU': ruRU,
    },
})

// Import Quasar css
import '@quasar/extras/material-icons/material-icons.css'
import 'quasar/src/css/index.sass'
import './styles/app.scss'

import iconSet from 'quasar/icon-set/material-icons'

import App from './App.vue'

const app = createApp(App)

app.use(i18nInstance)
app.use(router)

app.use(Quasar, {
    plugins: {
        Loading,
        Notify,
    },
    iconSet,
    config: {
        brand: {
            primary: '#008080',
            secondary: '#ebedf0',
            accent: '#9C27B0',
            positive: '#21BA45',
            negative: '#ff3c2e',
            info: '#31CCEC',
            warning: '#F2C037',
            gray: '#9299a3',
        },
    },
})

app.mount('#app')
